
import React from "react"
import { ArrowLeftFromLine, ArrowRightFromLine } from "lucide-react"
import { appStore } from "lib/state"
import { cn } from "lib/utils"


export default function PresetsHandle({ expanded, setExpanded }:{ expanded:boolean; setExpanded:any }){
  
  const { store, AppStore }:any = appStore() 
  const { update } = AppStore 
  
  return (
    <div 
      className={cn(
        "absolute z-30 w-12 h-12 top-10 rounded-full bg-amber-400 cursor-pointer",
        expanded === true ? "left-[-23px] bottom-0" : "left-0 bottom-0"
      )} 
      style={{ clipPath: "inset(0 24px 0 0)" }}
      onClick={() => setExpanded(!expanded) } 
    >
      <div className="w-full h-full flex justify-start items-center pl-1">
      { expanded === false ? <ArrowLeftFromLine className="w-4 h-4 my-auto stroke-2 stroke-teal-900" /> : <ArrowRightFromLine className="w-4 h-4 my-auto stroke-2 stroke-teal-900" /> }
      </div>
    </div>
  )
}